export type ServiceItem = {
    iconId: 'monitor' | 'smartphone' | 'shopping-cart' | 'layers' | 'git-branch' | 'sparkles';
    title: string;
    description: string;
    features: string[];
};

export type ServicesMock = {
    title: string;
    subtitle: string;
    services: ServiceItem[];
    ctaBlock: {
        title: string;
        text: string;
        buttonLabel: string;
    };
};

export const servicesMock: ServicesMock = {
    title: 'What I Do',
    subtitle: 'Expertise in building modern web solutions from concept to deployment',
    services: [
        { iconId: 'monitor', title: 'React Applications', description: 'Building modern, responsive web applications with React ecosystem', features: ['React + Redux', 'TypeScript', 'State Management', 'API Integration'] },
        { iconId: 'smartphone', title: 'Next.js Development', description: 'Creating high-performance applications with server-side rendering', features: ['SEO Optimized', 'Static Generation', 'Server Components', 'Full-Stack Apps'] },
        { iconId: 'shopping-cart', title: 'E-commerce Solutions', description: 'Developing scalable online stores with WooCommerce and Laravel', features: ['WooCommerce', 'Custom Themes', 'Payment Integration', 'Inventory Systems'] },
        { iconId: 'layers', title: 'CMS Development', description: 'Building custom solutions with WordPress, Craft, October and Strapi', features: ['WordPress & WooCommerce', 'Craft CMS', 'October CMS', 'Strapi Headless'] },
        { iconId: 'git-branch', title: 'Backend & API', description: 'Developing robust server-side applications with Node.js, PHP and Laravel', features: ['Node.js + Express', 'PHP + Laravel', 'REST APIs', 'MySQL & MongoDB'] },
        { iconId: 'sparkles', title: 'Frontend Engineering', description: 'Crafting pixel-perfect interfaces with modern CSS and JavaScript', features: ['HTML/CSS/SASS', 'JavaScript/TypeScript', 'Three.js 3D', 'Figma to Code'] },
    ],
    ctaBlock: {
        title: 'Want to Know More?',
        text: 'Currently working on exciting projects under NDA. To learn more about my work and discuss potential collaboration opportunities, feel free to reach out!',
        buttonLabel: 'Get in Touch',
    },
};
